import { useMutation } from '@tanstack/react-query';
import { showToast } from '@repo/ui';
import { templateTestingApi, type TemplateTestRequest, type SendEmailRequest } from '../api';

/**
 * Hook for template test mutation
 * @param onSuccessCallback - Optional callback to execute on successful test
 * @returns Mutation hook for testing templates
 */
export function useTestTemplate(onSuccessCallback?: (data: any) => void) {
  return useMutation({
    mutationFn: async (request: TemplateTestRequest) => {
      return templateTestingApi.testTemplate(request);
    },
    onSuccess: (data: any) => {
      if (data && data.success) {
        showToast.success('Template test completed!');
        onSuccessCallback?.(data);
      } else {
        showToast.error('Template test failed - invalid response');
      }
    },
    onError: (error: any) => {
      showToast.error(`Test failed: ${error.message}`);
      onSuccessCallback?.(null);
    },
  });
}

/**
 * Hook for sending test email mutation
 * @param onSuccessCallback - Optional callback to execute on successful email send
 * @returns Mutation hook for sending test emails
 */
export function useSendEmail(onSuccessCallback?: (data: any) => void) {
  return useMutation({
    mutationFn: async (request: SendEmailRequest) => {
      return templateTestingApi.sendTestEmail(request);
    },
    onSuccess: (data: any) => {
      showToast.success(data.message || 'Email sent successfully!');

      // If LocalStack email log URL is available, show additional success info
      if (data.details?.emailLogUrl) {
        setTimeout(() => {
          showToast.success(`Email log available for download: ${data.details.messageId}`);
        }, 1000);
      }

      onSuccessCallback?.(data);
    },
    onError: (error: any) => {
      showToast.error(`Email sending failed: ${error.message}`);
    },
  });
}

